import { FontWeight } from '@hhgtech/hhg-components/mantine'
import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      [theme.fn.smallerThan('sm')]: {
        gap: 8,
        padding: `${rem(14)} 0`,
        alignItems: 'center',
      },
      [theme.fn.largerThan('sm')]: {
        flexDirection: 'column',
        justifyContent: 'space-between',
        position: 'relative',
        height: 208,
        padding: 24,
        backgroundColor: theme.colors.gray[0],
        borderRadius: 24,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        '&:hover': {
          backgroundColor: theme.colors.blue[0],
          '.icon-wrapper': {
            backgroundColor: theme.fn.primaryColor(),
            transition: 'all 0.2s ease',
          },
          '.icon': {
            color: '#fff',
          },
        },
      },
    },
    heading: {
      color: theme.colors.gray[8],
      fontWeight: FontWeight.regular,
      [theme.fn.smallerThan('sm')]: {
        fontSize: rem(14),
        lineHeight: rem(22),
        letterSpacing: '-0.2px',
        order: 2,
      },
      [theme.fn.largerThan('sm')]: {
        fontWeight: FontWeight.semiBold,
      },
    },
    icon: {
      [theme.fn.smallerThan('sm')]: {
        order: 1,
        width: 32,
      },
      [theme.fn.largerThan('sm')]: {
        width: 80,
      },
    },
    iconBtn: {
      position: 'absolute',
      right: 24,
      bottom: 24,
      width: 32,
      height: 32,
      borderRadius: '50%',
      backgroundColor: theme.colors.gray[1],
      [theme.fn.smallerThan('sm')]: {
        display: 'none',
      },
    },
  }
})
